module.exports = __webpack_public_path__ + "static/img/03.092e047.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour5/03.jpg
// module id = 7CAk
// module chunks = 0